import React from 'react';
import { useRecoilValue } from 'recoil';
import { MeasurementBanner as MeasurementBannerContent } from 'pages/common/components/MeasurementBanner';
import { measurementAtom } from 'pages/common/store/measurement';

export const MeasurementBanner = () => {
  const measurement = useRecoilValue(measurementAtom);
  const { price, serviceURL, title, currency } = measurement;

  if (!price || !serviceURL || !title || !currency) {
    return null;
  }

  return <MeasurementBannerContent priceMin={price} serviceURL={serviceURL} serviceName={title} />;
};
